export default {
	path: 'detailEvaluations',
	name: 'DetailEvaluationForm',
	component() {
		return import('@/components/detailEvaluation/DetailEvaluationForm.vue')
	},
	children: [
		{
			path: '',
			name: 'DetailEvaluationList',
			component() {
				return import('@/components/detailEvaluation/DetailEvaluationList.vue')
			},
		},
	],
}